import * as React from 'react';

import { DrawerContext } from '@notino/react-styleguide';

import { useWishlistStore } from '@containers/WishList/store';

import { StyledRadioButton } from './styled';

export const SortByOptionsList = () => {
  const { closeDrawer } = DrawerContext.useDrawerContext();
  const sortByOptions = useWishlistStore((x) => x.sortByOptions);
  const selectedSortBy = useWishlistStore((x) => x.selectedSortBy);
  const { setSelectedSortBy } = useWishlistStore((x) => x.actions);

  return (
    <div>
      {sortByOptions.map((o) => (
        <StyledRadioButton
          key={o.sortBy}
          disabled={false}
          checked={o.sortBy === selectedSortBy}
          onChange={() => {
            setSelectedSortBy(o.sortBy);
            closeDrawer();
          }}
        >
          {o.name}
        </StyledRadioButton>
      ))}
    </div>
  );
};
